import styled from "styled-components"

export const ActionsModalWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: var(--z-index-diary-actions-modal);
  background: rgba(5, 5, 5, 0.75);
  top: 0;
  left: 0;

  @media (min-width: 450px) {
    max-width: var(--app-max-width);
    transform: translateX(-50%);
    left: 50%;
  }
`

export const ActionsModalContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 24px;
  padding-bottom: 85px;
`

export const CloseButton = styled.div`
  position: absolute;
  width: 56px;
  height: 56px;
  bottom: 24px;
  right: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
`

export const ActionsBox = styled.div`
  border-radius: 24px;
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.7) 0%,
      rgba(255, 255, 255, 0.7) 100%
    ),
    linear-gradient(
      90deg,
      rgba(233, 228, 222, 0.9) 0%,
      rgba(224, 212, 235, 0.9) 100%
    );

  backdrop-filter: blur(20px);
  padding: 16px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(2, 1fr);
  gap: 8px;
  max-width: 400px;
`

export const ActionItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
  gap: 8px;
  flex: 1 1 0;

  border-radius: 16px;
  border: 2px solid #fff;
  background: rgba(255, 255, 255, 0.6);
  cursor: pointer;
`

export const ActionItemTitle = styled.h3`
  color: #05050c;
  font-size: 16px;
  align-items: center;
  gap: 4px;
  text-align: center;
  height: 16px;
  line-height: 16px;
`

export const WaterTrackerAction = styled.div`
  border-radius: 16px;
  border: 2px solid #fff;
  background: rgba(255, 255, 255, 0.6);
  grid-column: 1 / -1;

  display: flex;
  padding: 15px 0 13px 0;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`

export const WaterTrackerTitle = styled.div`
  color: #05050c;
  text-align: justify;
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
`
